import { DATE_RELATIONS } from '@frontend/api';

export const AMOUNT_AND_UNIT_DATE_RELATIONS = [
  DATE_RELATIONS.PREVIOUS,
  DATE_RELATIONS.NEXT,
  DATE_RELATIONS.IN_THE_LAST,
  DATE_RELATIONS.IN_THE_NEXT,
] as const;
